import { doc } from "firebase/firestore";
import { firestore } from "../firebase";
import { adminsPath } from './adminsPath';

const getAuthorizedUserRef = (id) => {
  return doc(firestore, adminsPath.admins, id)
}

export default getAuthorizedUserRef;
